<template>
  <v-layout>
    <v-toolbar color="blue" dark fixed app clipped-right>
      <v-toolbar-title>Skillers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- <v-btn flat >Rólunk</v-btn> -->
        <!--                <v-btn flat  @click="loginShow = !loginShow">-->
        <!--                    Bejelentkezés-->
        <!--                    <v-icon right dark>input</v-icon>-->
        <!--                </v-btn>-->
      </v-toolbar-items>
    </v-toolbar>

    <v-dialog v-model="loginShow" persistent max-width="600px">
      <v-snackbar
        v-model="error.show"
        color="error"
        top
        :timeout="error.timeout"
        text-xs-center
      >
        {{ error.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>
      <v-card>
        <v-card-title
          class="headline blue"
          primary-title
          dark
          style="color: white"
        >
          Bejelentkezés
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-form>
                  <v-text-field
                    prepend-icon="alternate_email"
                    name="login"
                    label="Email cím"
                    type="text"
                    v-model="formLogin.email"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Jelszó"
                    type="password"
                    v-model="formLogin.password"
                  ></v-text-field>
                </v-form>

                <!-- <router-link :to="{ name: 'registration'}" >
                                Regisztráció    
                            </router-link> -->
                <br />
                <router-link :to="{ name: 'newPassword' }">
                  Elfelejtettem a jelszavam
                </router-link>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="loginShow = !loginShow"> Mégsem </v-btn>
          <v-btn color="primary" @click="authenticate">
            Bejelentkezés
            <v-icon right dark>input</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Bejelentkezés folyamatban
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios';
import { setTimeout } from 'timers';

export default {
  components: {},
  data: () => ({
    drawer: false,
    formLogin: {
      email: '',
      password: '',
    },
    error: {
      show: false,
      code: '',
      message: '',
      timeout: 3500,
    },
    loader: false,
    loginModalShow: false,
  }),
  methods: {
    authenticate() {
      this.$store.dispatch('login');

      this.$data.loader = true;

      axios
        .post(this.$store.getters.getApiUrl + '/api/login', {
          email: this.$data.formLogin.email,
          password: this.$data.formLogin.password,
        })
        .then((response) => {
          if (response.data.token.length > 0) {
            this.$store.commit('loginSuccess', {
              token: response.data.token,
              isLoggedIn: true,
              currentUser: response.data.currentUser,
            });

            this.$store.commit('setIsAppState', {
              isApp: false,
            });

            var v = this;

            setTimeout(function () {
              v.$data.loader = false;
              v.$router.push({ path: '/home' });
            }, 2000);
          }
        })
        .catch((error) => {
          // console.log('error', error.response.data);

          var v = this;

          setTimeout(function () {
            v.$data.loader = false;
          }, 1000);

          setTimeout(function () {
            v.$data.error.message = error.response.data.message;
            v.$data.error.code = error.response.data.code;
            v.$data.error.show = true;
          }, 1000);
        });
    },
    loginShowFunction() {
      // this.$data.loginModalShow = !this.$data.loginModalShow
      // this.$emit('login-show', this.$data.loginModalShow)
    },
  },
  props: {
    loginShow: Boolean,
  },
  mounted: () => ({}),
};
</script>
